// src/components/dashboard/DashboardHeader.tsx
import React, { memo } from "react";
import { Plus } from "lucide-react";

interface DashboardHeaderProps {
  onCreateClick: () => void;
}

export const DashboardHeader = memo(
  ({ onCreateClick }: DashboardHeaderProps) => (
    <header className="relative z-50 pt-16 md:pt-24 px-6 max-w-[1400px] w-full mx-auto flex justify-between items-center">
      <h1 className="text-xl md:text-3xl font-black italic uppercase tracking-tighter">
        My <span className="opacity-40">Assets</span>
      </h1>
      <button
        onClick={onCreateClick}
        className="bg-white text-black px-5 py-2.5 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-yellow-400 transition-all flex items-center gap-2"
        aria-label="Create new creation"
      >
        <Plus size={14} strokeWidth={3} />
        <span className="hidden sm:inline">New Creation</span>
      </button>
    </header>
  ),
);

DashboardHeader.displayName = "DashboardHeader";
